import * as Yup from "yup"
import keycode from "keycode"
import { ReservedCombinations } from "./HotKeysExtensionForm.const"

export const tErrorNamespace = "error:fastReplies.hot-keys."

const getReservedByFirstKey = (firstKey: string): number[] =>
    ReservedCombinations.find(reserved => reserved.firstKey === keycode(firstKey))?.secondKeys || []

export const getHotKeysValidationSchema = () =>
    Yup.object().shape({
        FirstKey: Yup.string().required(`${tErrorNamespace}emptyValue`),
        SecondKey: Yup.string()
            .max(1, `${tErrorNamespace}maxOneCharacter`)
            .required(`${tErrorNamespace}emptyValue`)
            .test("oneOfReserved", `${tErrorNamespace}reserved`, function (value) {
                return !getReservedByFirstKey(this.parent.FirstKey).includes(keycode(value || ""))
            })
            .test("invalidCombination", `${tErrorNamespace}invalidCombination`, function (value) {
                if (!value) {
                    return false
                }

                return /[^`]/gi.test(value)
            })
    })
